import { AccountFeature, isAccountFeatureEnabled } from 'hooks/use-account-feature';
import { isTauriApp } from 'utils/is-tauri';
export const APP_SHELL_MODE_STORAGE_KEY = 'app-shell-mode';
export const DEFAULT_APP_SHELL_MODE = 'rocketlane';
const isAppShellMode = (value)=>value === 'rocketlane' || value === 'nitro-claw';
/**
 * Sync read of the persisted shell preference (web only).
 * Tauri always uses the Nitro Claw desktop shell when the account feature is on.
 */ export const getAppShellMode = ()=>{
    if (typeof window === 'undefined') {
        return DEFAULT_APP_SHELL_MODE;
    }
    try {
        const raw = window.localStorage.getItem(APP_SHELL_MODE_STORAGE_KEY);
        if (raw == null) {
            return DEFAULT_APP_SHELL_MODE;
        }
        const parsed = JSON.parse(raw);
        return isAppShellMode(parsed) ? parsed : DEFAULT_APP_SHELL_MODE;
    } catch (unused) {
        return DEFAULT_APP_SHELL_MODE;
    }
};
/**
 * Whether the DesktopAppShell (Nitro Claw nav) should render.
 * Requires `AccountFeature.NitroClaw`, and either Tauri or web mode `nitro-claw`.
 */ export const isNitroClawShell = ()=>{
    if (!isAccountFeatureEnabled(AccountFeature.NitroClaw)) {
        return false;
    }
    return isTauriApp() || getAppShellMode() === 'nitro-claw';
};
